module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simplert",
    class: _vm.classSimplert,
    attrs: {
      "role": "modal"
    },
    on: {
      "click": _vm.closeOverlay
    }
  }, [_c('div', {
    staticClass: "simplert__content",
    class: _vm.classContent
  }, [_c('div', {
    staticClass: "simplert__header"
  }, [(_vm.showXclose) ? _c('div', {
    staticClass: "simplert__x",
    on: {
      "click": _vm.justCloseSimplert
    }
  }, [_vm._v("╳")]) : _vm._e(), _vm._v(" "), (_vm.useIcon) ? _c('div', [(_vm.type === 'info') ? _c('div', {
    staticClass: "simplert__icon simplert__icon--info"
  }, [_c('div', {
    staticClass: "simplert__line simplert__line--info"
  }), _vm._v(" "), _c('div', {
    staticClass: "simplert__line simplert__line--info-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'success') ? _c('div', {
    staticClass: "simplert__icon simplert__icon--success"
  }, [_c('div', {
    staticClass: "simplert__line simplert__line--success"
  }), _vm._v(" "), _c('div', {
    staticClass: "simplert__line simplert__line--success-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'warning') ? _c('div', {
    staticClass: "simplert__icon simplert__icon--warning"
  }, [_c('div', {
    staticClass: "simplert__line simplert__line--warning"
  }), _vm._v(" "), _c('div', {
    staticClass: "simplert__line simplert__line--warning-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.type === 'error') ? _c('div', {
    staticClass: "simplert__icon simplert__icon--error"
  }, [_c('div', {
    staticClass: "simplert__line simplert__line--error"
  }), _vm._v(" "), _c('div', {
    staticClass: "simplert__line simplert__line--error-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.customIconUrl !== '') ? _c('div', {
    staticClass: "simplert__icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.customIconUrl
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "simplert__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "simplert__body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "simplert__footer"
  }, [(_vm.useConfirmBtn && !_vm.hideAllButton) ? _c('button', {
    class: _vm.classBtnConfirm,
    on: {
      "click": _vm.whenConfirm
    }
  }, [_vm._v("\n        " + _vm._s(_vm.customConfirmBtnText) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.hideAllButton) ? _c('button', {
    class: _vm.classBtnClose,
    on: {
      "click": _vm.closeSimplert
    }
  }, [_vm._v("\n        " + _vm._s(_vm.customCloseBtnText) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f0bd48","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue2-simplert/src/Simplert.vue
// module id = 675
// module chunks = 4